<template>
    <div>

        <div v-if="isLoading">
            <div class="row">
                <div class="col-md-12 text-center pt-5 pb-5 mt-5 pb-5">
                    <i class="fa fa-circle-notch fa-spin fa-10x fa-fw" aria-hidden="true"></i>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="widget has-shadow">
                    <div class="widget-header bordered no-actions d-flex align-items-center">
                        <h2>BAE Systems Reports</h2>
                    </div>
                    <div class="widget-body border-bottom">
                        <router-link to="/bae-systems-reports/add"
                                     class="btn btn-outline-primary btn-square pt-3 pb-3 mt-3 mb-3"
                                     style="display:block;width:100%">Start New Report
                        </router-link>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="widget has-shadow">
                    <div class="widget-header bordered no-actions d-flex align-items-center">
                        <h3 class="d-none">
                            BAE Systems Reports ({{ baeSystemsReports.length }})</h3>
                        <h3>
                            BAE Systems Reports ({{ filteredCount }})</h3>
                    </div>
                    <div class="widget-body">
                        <div class="input-group pb-5">
                        <span class="input-group-addon pr-0 pl-0">
                        <a class="btn" href="#">
                        <i class="fa fa-search"></i>
                        </a>
                        </span>
                            <input type="text" class="form-control dynamic-search" name="search_term"
                                   v-model="search"
                                   placeholder="Search (enter at least 3 characters)">
                        </div>


                        <div class="container">

                            <bae-systems-report
                                    v-for="report in filteredReports"
                                    v-bind:key="report.site_bae_systems_report_id"
                                    v-bind:baeSystemsReport="report"
                            >
                            </bae-systems-report>


                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import BaeSystemsReport from '@/components/BaeSystemsReport.vue';

    export default {
        data() {
            return {
                baeSystemsReports: [],
                isLoading: true,
                search: ''
            }
        },
        components: {
            BaeSystemsReport,
        },
        computed: {
            filteredReports() {
                if (this.baeSystemsReports.length > 0) {
                    return this.baeSystemsReports.filter(item => {
                        return (item.door_identifier && item.door_identifier.toLowerCase().indexOf(this.search.toLowerCase()) > -1)
                            || (item.door_location && item.door_location.toLowerCase().indexOf(this.search.toLowerCase()) > -1)
                    });
                } else {
                    return [];
                }
            },
            filteredCount() {
                return this.filteredReports.length;
            }
        },
        mounted() {
            const modulesData = this.$session.get('enabled_modules');
            if(!modulesData || modulesData.indexOf('BSR') === -1) {
                this.$router.push('/');
                return;
            }
            
            this.getReports();
        },
        methods: {
            getReports() {
                var vmt = this;
                this.getDb(function onConnected(db) {
                    vmt.baeSystemsReports = [];
                    try {
                        var objectStore = db.transaction('bae_systems_reports').objectStore('bae_systems_reports');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                vmt.isLoading = false;
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (vmt.baeSystemsReports) {
                                        if (
                                            (cursor.value.is_deleted === undefined || cursor.value.is_deleted === false) &&
                                            (cursor.value.is_complete === undefined || cursor.value.is_complete === false)
                                        ) {
                                            vmt.baeSystemsReports.push(cursor.value)
                                        }
                                    }
                                    cursor.continue();
                                }
                            };
                        }
                    } catch (e) {
                    }
                });
            },
        }
    }
</script>